import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import TopNav from '../../TopNav/TopNav';
import JobNav from '../JobNav';
import Comments from './Comments';
import Tbd from './Tbd';
import ChangedOptions from './ChangedOptions';
import CustomOptions from './CustomOptions';
import WarningReports from './WarningReports';
import JobOverviewBar from '../JobOverviewBar';
import GenerateReport from '../PrintJob/GenerateReport';
import { usePermissions } from '../../../hooks/usePermissions';
import useJobHandler, { useJobSync } from '../../../functions/JobHandler';
import VTLossCalculator from '../../EngineeringPage/VTLossCalculator';
import ChangeLog from '../../MainPage/ChangeLog';

const AdditionalItems = () => {
  const currentKey = "additionalItems";
  const jobId = useSelector((state) => state.jobId.jobId);
  const { canView, isAdmin, userRoles } = usePermissions();
  
  const hasChangeLogPermission = isAdmin() || userRoles.includes('Apps');
  const hasVTCalculatorPermission = isAdmin() && canView('portal.additional-items.vt-calculator');

  // Add the job handler to manage jobId state synchronization
  useJobHandler();
  
  // Sync job data when this page loads
  const { syncJob } = useJobSync();
  
  useEffect(() => {
    if (jobId) {
      console.log("AdditionalItems: Syncing job data for jobId:", jobId);
      syncJob({ reuseRecent: true })
        .then((result) => {
          if (result && result.fieldsUpdated > 0) {
            console.log(`AdditionalItems: Updated ${result.fieldsUpdated} fields across ${result.sectionsUpdated} sections`);
          } else {
            console.log("AdditionalItems: Job data is already up to date");
          }
        })
        .catch((error) => {
          console.error("AdditionalItems: Failed to sync job data:", error);
        });
    }
  }, [jobId, syncJob]);

  return (
    <div>
      <TopNav />
      <JobOverviewBar />
      <JobNav keyValue={currentKey} />
      <section className="mb-4" aria-labelledby="additional-portal-heading">
        <h2 id="additional-portal-heading" className="additional-items-section-heading">Production Portal References</h2>
        <Accordion alwaysOpen>
          {hasChangeLogPermission && (
            <Accordion.Item eventKey="changeLog">
              <Accordion.Header>
                <h3>Change Log</h3>
              </Accordion.Header>
              <Accordion.Body>
                <ChangeLog embedded />
              </Accordion.Body>
            </Accordion.Item>
          )}
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <h3>Comments</h3>
            </Accordion.Header>
            <Accordion.Body>
              <Comments />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <h3>Tbd</h3>
            </Accordion.Header>
            <Accordion.Body>
              <Tbd />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5" className="additional-export-accordion">
            <Accordion.Header>
              <h3>Generate Report</h3>
            </Accordion.Header>
            <Accordion.Body>
              <GenerateReport />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </section>
      <section className="mb-4" aria-labelledby="additional-sales-portal-heading">
        <h2 id="additional-sales-portal-heading" className="additional-items-section-heading">Sales Portal References</h2>
        <Accordion alwaysOpen>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <h3>Changed Options</h3>
            </Accordion.Header>
            <Accordion.Body>
              <ChangedOptions />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <h3>Custom Options</h3>
            </Accordion.Header>
            <Accordion.Body>
              <CustomOptions />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>
              <h3>Warning Reports</h3>
            </Accordion.Header>
            <Accordion.Body>
              <WarningReports />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </section>
      <Accordion alwaysOpen>
        {hasVTCalculatorPermission && (
          <Accordion.Item eventKey="8">
            <Accordion.Header>
              <h3>VT Loss Calculator</h3>
            </Accordion.Header>
            <Accordion.Body>
              <VTLossCalculator useJobData={true} />
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
    </div>
  );
};

export default AdditionalItems;
